<div class="ng-bento">
	<div class="row" [hidden]="isComponentExpanded"> <!--ngIf doesn't work in this case.
	See the issue https://stackoverflow.com/questions/58646928/load-dynamic-component-within-ngif-createcomponent-is-undefined-->
		<bento-side-nav attr.aria-label="{{'onvio.setup.migrations.sidenav.label' | translate }}"
						data-qe-id="migration-dashboard-side-nav"
						class="migration-side-nav"
						[items]="items"
						(select)="onSelect($event)">
		</bento-side-nav>
		<div class="migration-container-right col-9">
			<ng-template #productMigrationHost></ng-template>
		</div>
	</div>
	<div [hidden]="!isComponentExpanded">
		<ng-template #migrationExpandComponentHost></ng-template>
	</div>
</div>
